const resultQueryParams = ["q", "cid", "refine", "sort"];

const getParamValues = (searchParams, param) =>
  searchParams.getAll(param).filter(Boolean).sort();

const getIsParamChanged = (currentSearchParams, nextSearchParams, param) => {
  const currentValues = getParamValues(currentSearchParams, param);
  const nextValues = getParamValues(nextSearchParams, param);

  return currentValues.join("|") !== nextValues.join("|");
};

const getIsResultQueryChanged = ({
  currentQuery = "",
  nextQuery = "",
} = {}) => {
  const currentSearchParams = new URLSearchParams(currentQuery);
  const nextSearchParams = new URLSearchParams(nextQuery);

  return resultQueryParams.some((param) =>
    getIsParamChanged(currentSearchParams, nextSearchParams, param),
  );
};

export default getIsResultQueryChanged;
